module.exports = __webpack_public_path__ + "img/web-P4-2-1.f7a78d64.png";